import React from 'react';
import MuiLoadingButton, { LoadingButtonProps as MuiLoadingButtonProps } from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';

const Styled = styled<React.FC<MuiLoadingButtonProps>>(MuiLoadingButton)`
  height: 48px;
`;

export default Styled;
